/**
 * 미디어(광고 소재 + 오가닉 게시물) 고르개의 값 — 탭 · 채널 · 국가 · 형식.
 *
 * 콘텐츠 허브 · 브랜드 허브 · 「질문 → 화면」 조건표(`ask-screens`)가 함께 읽는 한 벌이다.
 */

/** 미디어 탭 */
export const MEDIA_TABS = ['all', 'ads', 'organic', 'products'] as const;
export type MediaTab = (typeof MEDIA_TABS)[number];

/** 광고 채널 — Meta 광고 라이브러리 하나 */
export const MEDIA_AD_CHANNELS = ['meta'] as const;

/** 오가닉 채널 — 게시물 `source` 값. 원장에 실제로 쌓이는 채널을 다 편다(커뮤니티·리뷰 사이트 포함) */
export const MEDIA_ORGANIC_CHANNELS = [
  'instagram',
  'tiktok',
  'youtube',
  'x',
  'threads',
  'naverblog',
  'navercafe',
  'naverkin',
  'reddit',
  'atcosme',
  'lips',
  'dcinside',
  'theqoo',
  'ppomppu',
] as const;

export type MediaChannel = (typeof MEDIA_AD_CHANNELS)[number] | (typeof MEDIA_ORGANIC_CHANNELS)[number];

/**
 * 이 화면에서 **실제로 고를 수 있는** 오가닉 채널 — 나머지는 자물쇠로 두고 Research로 보낸다.
 * ⚠️ 채널을 하나도 안 고른 「전체」도 이 셋만 묻는다 — 잠긴 채널이 슬쩍 섞여 나오면 잠근 뜻이 없다.
 */
export const MEDIA_LITE_CHANNELS: readonly MediaChannel[] = ['instagram', 'tiktok', 'youtube'];

/** 5대 SNS — 인스타그램 · 틱톡 · 유튜브 · X · 스레드(블로그 · 카페 · 커뮤니티 · 리뷰를 뺀 소셜포스팅) */
export const MEDIA_SNS_CHANNELS: readonly MediaChannel[] = ['instagram', 'tiktok', 'youtube', 'x', 'threads'];

/** 채널 고르는 자리의 묶음 — SNS 와 커뮤니티·리뷰를 나눠 둔다(한 줄로 늘어놓으면 못 찾는다) */
export const MEDIA_ORGANIC_CHANNEL_GROUPS: { label: string; channels: readonly MediaChannel[] }[] = [
  { label: '소셜포스팅', channels: MEDIA_SNS_CHANNELS },
  { label: '커뮤니티·리뷰', channels: ['naverblog', 'navercafe', 'naverkin', 'dcinside', 'theqoo', 'ppomppu', 'reddit', 'atcosme', 'lips'] },
];

/** 국가 — 광고 `adCountry` · 오가닉 `market` 이 같은 대문자 국가 코드다. 두 원장 모두에 걸린다 */
export const MEDIA_COUNTRIES = ['KR', 'US', 'JP', 'CN', 'TW', 'VN', 'TH', 'ID', 'MY', 'PH', 'IN', 'GB', 'FR', 'DE', 'ES', 'BR', 'AU', 'CA'] as const;
export type MediaCountry = (typeof MEDIA_COUNTRIES)[number];

/** 형식 — 광고 `mediaType` 값. ⚠️ 광고 원장은 이미지·영상 둘뿐이다(캐러셀은 이미지에 합쳐 센다) */
export const MEDIA_FORMATS = ['image', 'video'] as const;
export type MediaFormat = (typeof MEDIA_FORMATS)[number];
